'use client';

import { css } from '@bts-web/utils-style-engine';
import { useFeatureFlag } from '../../statsig/sdk/provider';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';
import { RegularInfo } from '../../common/svgIcons/RegularInfo';
import { EstimatedEarningsDrawer } from './EstimatedEarningsDrawer.use-client';
import { PerformanceDisclaimerTranslations } from '../types';

interface EstimatedEarningsInfoIconProps {
  translations: PerformanceDisclaimerTranslations;
  className?: string;
}

const iconButtonStyles = css({
  background: 'none',
  border: 'none',
  padding: '0',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
});

const EstimatedEarningsInfoIcon = ({
  translations,
  className,
}: EstimatedEarningsInfoIconProps) => {
  const { openDrawer } = useModalDrawerContext();

  const feature_isUkLicensed = useFeatureFlag('feature_isUkLicensed');

  if (!feature_isUkLicensed) {
    return null;
  }

  const handleClick = () => {
    openDrawer(
      () => (
        <EstimatedEarningsDrawer
          title={translations.estimatedEarningsTitle}
          body={translations.estimatedEarningsBody}
          gotItLabel={translations.gotIt}
        />
      ),
      { position: 'bottom' },
    );
  };

  return (
    <button
      type="button"
      className={
        className ? `${className} ${iconButtonStyles}` : iconButtonStyles
      }
      onClick={handleClick}
      aria-label={translations.estimatedEarningsTitle}
    >
      <RegularInfo size={16} color="neutrals.text_secondary" />
    </button>
  );
};

export { EstimatedEarningsInfoIcon };
